<template>
  <div class="apply">
    <div class="top">
      <p>
        <i class="iconfont icon-weixinzhifu"></i>
        微信支付|收银台
      </p>
    </div>
    <div class="main">
      <div class="left">
        <div>
          <img :src="imgSrc1" alt="失败">
        </div>
      </div>
      <div class="right">
        <p>医诺云诊所({{info.hospitalName}})订单</p>
        <div>
          <span>￥</span>
          <span>{{info.amount}}</span>
        </div>
        <div class="payStateBox">
          <p>
            <span class="red"><i class="iconfont icon-xiangqing"></i>支付失败</span>
          </p>
          <p>
            <span @click="toBack">返回重新支付</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'applyerror',
  props:['info'],
  data () {
    return {
      imgSrc1:require('@/assets/img/error.png')
    }
  },
  mounted(){
    console.log(this.info);
  },
  methods:{
    toBack(){
      this.$emit('modalShow',false);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.apply{
  width: 800px;
  width: 100%;
  padding: 20px;
  height: 60%;
  margin: 0 auto;
  height: 450px;
  display: flex;
  flex-flow: column nowrap;
  background-color: #fff;
}
.apply>.top{
  height: 10%;
  display: table;
}
.apply>.top>p{
  display: table-cell;
  vertical-align: middle;

}
.apply>.top>p>i{
  color: #00ab45;
}
.apply>.main{
  height: 85%;
  display: flex;
  justify-content: space-between;
  padding:30px 30px 55px 30px;
}
.apply>.main>div{
  width: 50%;
}
.apply>.main>.left{
  /* background-color: aqua; */

}
.apply>.main>.left>.code>p{
  width: 50%;
  min-width: 220px;
  text-align: center;
  margin: 0 auto;
  font-size: 14px;
}
.apply>.main>.left>.code>p:first-child{
  height: 220px;
  line-height: 220px;
}
.apply>.main>.left>.code>p>img{
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}
/* 成功失败左侧显示图片 */
.apply>.main>.left>div{
  width: 100%;
}
.apply>.main>.left>div>img{
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.payStateBox{
  display: block !important;
}
.payStateBox>p{
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
}
.payStateBox>p>span>i{
  font-size: 22px;
}
.payStateBox>p>span{
  font-size: 24px;
}
.payStateBox>p{
  height: 50px;
  line-height: 50px;
}
.payStateBox>p:first-child>span{
  color: #09b354;
}
.payStateBox>p:first-child>span.red{
  color: #de4d43;
}
.payStateBox>p:last-child>span{
  font-size: 18px;
  text-align: center;
  display: inline-block;
  border: 1px solid #999;
  padding: 0 35px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.apply>.main>.right{
  padding: 5px 0 0 10%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
}
.apply>.main>.right>p{
  height: 28px;
  line-height: 28px;
}
.apply>.main>.right>div{
  height: 80px;
  line-height: 80px;
  display: flex;
  justify-content: first baseline;
}
.apply>.main>.right>div>span{
  font-size: 20px;
}
.apply>.main>.right>div>span:nth-child(2){
  font-size: 38px;
  font-weight: 500;
  color: #091025;
}
.apply>.main>.right>ul>li{
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
}
.apply>.main>.right>ul>li>span:nth-child(1){
  color: #9097ac;
  width: 20%;
  min-width: 100px;
}
.apply>.main>.right>ul>li>span{
  color: #091025;
  font-size: 14px;
}


</style>



// WEBPACK FOOTER //
// src/components/ApplyError.vue